import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=39d6144a&"
import script from "./dropdown.vue?vue&type=script&lang=js&"
export * from "./dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports